import {Contract, Entity} from 'interactors/contracts/types';
import {applyContract} from './apply';

export function withContract(
  factory: Factory<Entity>,
  ...rest: [string, Contract]
): Factory<Entity> {
  return function apply(...args: unknown[]): Entity {
    const entity = factory(...args);
    return applyContract(entity, ...rest);
  };
}
